import { all } from 'redux-saga/effects';
import userSagas from './userSagas';
import assessmentReportsSagas from './assessmentReportsSagas';
export default function* rootSaga() {
  yield all([userSagas(), , assessmentReportsSagas()]);
}
